import React from 'react';
import styled from 'styled-components';
import { colors } from '../theme/ColorTheme';
import mediaQ from '../theme/responsive';
import Modal from './Modal'
import infoIcon from '../../assets/img/infoIcon.png';

export default class InfoBox extends React.Component {

    state = {
        show: false
      };
      showModal = e => {
        this.setState({
          show: true
        });
      };
      hideModal = e => {
        this.setState({
          show: false
        });
      };
    render() {


        return (
            <React.Fragment>


              <InfoIcon src={infoIcon}
                  onClick={e => {
                    this.showModal(e);
                  }}
                >
                  {this.props.clickable}
                </InfoIcon>


                <Modal onClose={this.hideModal} show={this.state.show} headline={this.props.headline} innerContent={this.props.content} positioning={this.props.positioning}/>



            </React.Fragment>
        );
    }
}



const InfoIcon = styled.img`
    position:relative;
    margin-left:1rem;
    vertical-align: middle;
    width: 22px;
    height: 22px;
    cursor: pointer;
`;



